import Conversation from '../conversation/conversation'
import Chat from '../layout/chat'
import ChatFrame from '../layout/chat-frame'

const AppView = () => {
  return (
    <Chat>
      <ChatFrame>
        <Conversation />
      </ChatFrame>
    </Chat>
  )
}

export default AppView
